import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../api/axios";
import AuthContext from "../../context/AuthContext";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LoginForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthState } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [password, setPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const normalizedEmail = email.trim();
    setValidEmail(EMAIL_REGEX.test(normalizedEmail));
  }, [email]);

  useEffect(() => {
    setErrorMessage("");
  }, [email, password]);

  const submitForm = async (e) => {
    e.preventDefault();
    const normalizedEmail = email.trim();

    try {
      const response = await axiosInstance.post("/api/auth/login", {
        email: normalizedEmail,
        password,
      });
      setAuthState({ isAuthenticated: true, user: response.data.user });
      const from = location.state?.from;
      navigate(from?.pathname === "/school-email"
        ? { pathname: "/school-email", hash: from.hash || "" }
        : "/dashboard", { replace: true });
    } catch (err) {
      // console.log(err);
      setErrorMessage("Invalid credentials.");
    }
  };

  return (
    <form className="auth-form" onSubmit={submitForm}>
      <p className="subtitle">
        Present your account details to continue your journey.
      </p>
      <div className="auth-form-inner">
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {email && !validEmail && (
          <p className="error-message">Must be a valid email address</p>
        )}
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            id="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            placeholder="Your password"
            id="password"
            className="auth-form-password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <p className="auth-meta">
          <a href="/register">Don't have an account? </a>
          <br></br>
          <a href="/reset">Forgot Password?</a>
        </p>

        <button
          type="submit"
          className="button"
          placeid="auth-button"
          disabled={!validEmail || !password}
        >
          Continue journey
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
